{
  "header": {
    "title": "Data explorer",
    "description": "Create, manage, and analyze employee surveys to gather deeper insights",
    "createButton": "Create new report"
  },
  "content": {
    "searchInput": {
      "placeholder": "Search surveys"
    },
    "tagsDropdown": {
      "triggerLabel": "Tags",
      "placeholder": "Find a tag",
      "options": {
        "employeeEngagement": "Employee Engagement",
        "workplaceCulture": "Workplace Culture",
        "teamSatisfaction": "Team Satisfaction",
        "performanceFeedback": "Performance Feedback",
        "organizationalImprovement": "Organizational Improvement",
        "usa": "USA",
        "europe": "Europe",
        "asia": "Asia",
        "ukraine": "Ukraine"
      }
    }
  },
  "columns": {
    "reportName": "Report name",
    "tags": "Tags",
    "creator": "Creator",
    "status": "Status"
  },
  "detailsPage": {
    "header": {
      "backButton": "Back to Data explorer",
      "description": "Create, manage, and analyze employee surveys to gather deeper insights",
      "shareReportButton": "Share report",
      "editReportButton": "Edit report"
    },
    "cardMetrcisSection": {
      "title": "Avg. Employee count"
    },
    "leaderMetrcisSection": {
      "title": "Leader’s metrics",
      "description": "This chart visualizes how employees with different tenure lengths responded to the statement.",
      "chart": {
        "title": "Job satisfaction score"
      }
    }
  },
  "builder": {
    "header": {
      "backButton": "Back to Data explorer",
      "addDescriptionButton": "Add description",
      "cancelButton": "Cancel",
      "saveReportButton": "Save report"
    },
    "content": {
      "notSupportedLayout": "1/3 layout not supported",
      "inputs": {
        "dateRange": {
          "label": "Date range"
        },
        "department": {
          "label": "Department"
        },
        "leader": {
          "label": "Leader"
        },
        "gender": {
          "label": "Gender"
        },
        "location": {
          "label": "Location"
        },
        "tenure": {
          "label": "Tenure"
        }
      },
      "charts": {
        "heatmap": {
          "title": "Intensity across departments"
        },
        "distribution": {
          "title": "Distribution of responses"
        },
        "improvement": {
          "title": "Top 5 improving questions in Work-Life Balance"
        },
        "decline": {
          "title": "Top 5 declining questions in Work-Life Balance"
        },
        "text": {
          "title": "Leader’s metrics",
          "description": "Leader performance metrics and feedback overview"
        }
      }
    },
    "sidebar": {
      "text": {
        "textHeading": {
          "title": "Heading",
          "description": "Total employees in the survey",
          "data": {
            "title": "Leader’s metrics",
            "description": "Leader performance metrics and feedback overview"
          }
        },
        "textSubtitle": {
          "title": "Subtitle",
          "description": "Total employees in the survey",
          "data": {
            "title": "Leader’s metrics",
            "description": "Leader performance metrics and feedback overview"
          }
        },
        "textBodyText": {
          "title": "Body text",
          "description": "Total employees in the survey",
          "data": {
            "title": "Leader’s metrics",
            "description": "Leader performance metrics and feedback overview"
          }
        }
      },
      "numbers": {
        "numbersAvgEmployee": {
          "title": "Avg. employee count",
          "description": "Total employees in the survey",
          "data": {
            "title": "Avg. employee count",
            "description": "Total employees in the survey"
          }
        },
        "numbersResponseCount": {
          "title": "Response count",
          "description": "Number of submitted responses",
          "data": {
            "title": "Response count",
            "description": "Number of submitted responses"
          }
        },
        "numbersParticipationRate": {
          "title": "Participation rate",
          "description": "Percentage of employees who responded",
          "data": {
            "title": "Participation rate",
            "description": "Percentage of employees who responded"
          }
        },
        "numbersAverageScore": {
          "title": "Average score",
          "description": "Percentage of employees who responded",
          "data": {
            "title": "Average score",
            "description": "Percentage of employees who responded"
          }
        },
        "numbersEnps": {
          "title": "eNPS",
          "description": "Percentage of employees who responded",
          "data": {
            "title": "eNPS",
            "description": "Percentage of employees who responded"
          }
        }
      },
      "graphs": {
        "graphsAvgEmployee": {
          "title": "Avg. employee count",
          "description": "Total employees in the survey",
          "data": {
            "title": "Avg. employee count",
            "description": "Total employees in the survey"
          }
        }
      }
    }
  }
}
